/**
 * Device ID Utility
 *
 * Manages a stable device identifier stored in localStorage.
 * Used for New Device Verification (NDV) feature.
 */

const DEVICE_ID_KEY = 'amnpass_device_id';

/**
 * Generate a new UUID v4
 */
function generateUUID(): string {
  return crypto.randomUUID();
}

/**
 * Get the current device ID, or create one if it doesn't exist.
 * The device ID is stored in localStorage and persists across sessions.
 */
export function getOrCreateDeviceId(): string {
  // Check if we already have a device ID
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    // Generate a new device ID
    deviceId = generateUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}

/**
 * Get the current device ID without creating one.
 * Returns null if no device ID exists.
 */
export function getDeviceId(): string | null {
  return localStorage.getItem(DEVICE_ID_KEY);
}

/**
 * Clear the device ID (useful for testing or when user wants to reset).
 * This will cause the device to be treated as "new" on next login.
 */
export function clearDeviceId(): void {
  localStorage.removeItem(DEVICE_ID_KEY);
}

